import * as preact from "preact";

import { type PreactPageProps } from "pages/PreactPage";
import ReaderReviewSessionView from "views/ReaderReviewSessionView";

interface ReaderReviewPageOptions {
  bookID: string;
  position: number;
  returnPosition: number;
}

export default class ReaderReviewPageView extends preact.Component<PreactPageProps> {
  render() {
    const options = this.props.options as ReaderReviewPageOptions | undefined;
    if (!options) {
      return null;
    }

    return (
      <ReaderReviewSessionView
        bookID={options.bookID}
        position={options.position}
        appRouter={this.props.appRouter}
        returnPosition={options.returnPosition}
      />
    );
  }
}
